import React from 'react';
import { AuthProvider } from '../../features/auth/context/AuthContext';
import { CookieProvider } from '../../features/cookies/context/CookieConsentContext';

export default function AppProviders({ children }) {
  return (
    <CookieProvider>
      <AuthProvider>{children}</AuthProvider>
    </CookieProvider>
  );
}
